import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
import { Game3Map, getRndFromArray, useStore, GameStatus } from '../lib'
import { Guide, Image as Img, Loader, ModalAlert, ModalImage, ScoreStats, SideNav } from '../components'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { GameFrame } from './GameFrame'

export const Game3 = () => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false)
  const [isFinished, setIsFinished] = useState<boolean>(false)
  const [imgWidth, setImgWidth] = useState<number>((window.innerWidth * 0.48) / 2)
  const [allAnimals, setAllAnimals] = useState<any>(null)
  const [displayedAnimals, setDisplayedAnimals] = useState<any[]>([])
  const [correctAnimals, setCorrectAnimals] = useState<string[]>([])
  const [currentAnimal, setCurrentAnimal] = useState<any>(null)
  const [statusA, setStatusA] = useState<GameStatus>(null)
  const [statusB, setStatusB] = useState<GameStatus>(null)
  const [statusC, setStatusC] = useState<GameStatus>(null)
  const [statusD, setStatusD] = useState<GameStatus>(null)
  const [gameStartTime, setGameStartTime] = useState<number>(+new Date())
  const [gameEndTime, setGameEndTime] = useState<number>()
  const history = useHistory()
  const refGuide: any = useRef(null)
  const refModalAlert: any = useRef(null)
  const refModalImage: any = useRef(null)
  // const { id }: any = useParams()
  const { state, patchState } = useStore()

  const preloadImages = async () => {
    const onImgLoad = async (imageEl: HTMLImageElement) => {
      return new Promise(resolve => {
        imageEl.onload = () => resolve(imageEl)
      })
    }
    const all = [...Game3Map.hooves.data, ...Game3Map.paws.data].flatMap(a => [a.img, a.imgDetail, a.imgFootprint])
    for (const imgSrc of all) {
      const img = new Image()
      img.src = imgSrc
      await onImgLoad(img)
    }
    setIsInitialized(true)
    return true
  }

  const selectDisplayedAnimals = () => {
    const hooves = getRndFromArray(allAnimals.hooves.data, 2)
    const paws = getRndFromArray(allAnimals.paws.data, 2)
    setDisplayedAnimals([...paws, ...hooves])
  }

  useEffect(() => {
    // console.warn({allAnimals, isInitialized, Game3Map}); // TODO: remove
    if (!allAnimals && !isFinished) {
      const all = JSON.parse(JSON.stringify(Game3Map))
      setAllAnimals(all)
    } else if (allAnimals && !isInitialized) {
      preloadImages()
      selectDisplayedAnimals()
      patchState({ score: 0, errors: 0 }) // todo
      setTimeout(() => refGuide?.current?.openModal(Game3Map.intro), 500)
    }
  }, [allAnimals])

  useEffect(() => {
    // console.warn({displayedAnimals, isFinished, isInitialized, allAnimals}); // TODO: remove
    if (displayedAnimals.length > 0) {
      const a = getRndFromArray([...displayedAnimals])
      // console.warn(a, displayedAnimals); // TODO: remove
      setCurrentAnimal(a)
    } else if (!displayedAnimals.length && !isFinished) {
      // todo nope
      // setIsFinished(true)
      // patchState({ games: { ...state.games, game1: { score: state.score, errors: state.errors } } })
      // refModalAlert?.current?.openModal([`Hotovo celek, score: ${state.score}, errors: ${state.errors}`])
    }
  }, [displayedAnimals])

  const selectAnimal = (id: string) => {
    const isCorrect = id === currentAnimal?.id
    // console.warn(id, isCorrect); // TODO: remove
    let aIndex = 0
    for (const an of displayedAnimals) {
      if (an.id === id) {
        switch (aIndex) {
          case 0:
            if (statusA === 'success') {
              return
            }
            setStatusA(isCorrect ? 'success' : 'error')
            if (!isCorrect) {
              setTimeout(() => setStatusA(null), 2000)
            }
            break
          case 1:
            if (statusB === 'success') {
              return
            }
            setStatusB(isCorrect ? 'success' : 'error')
            if (!isCorrect) {
              setTimeout(() => setStatusB(null), 2000)
            }
            break
          case 2:
            if (statusC === 'success') {
              return
            }
            setStatusC(isCorrect ? 'success' : 'error')
            if (!isCorrect) {
              setTimeout(() => setStatusC(null), 2000)
            }
            break
          case 3:
            if (statusD === 'success') {
              return
            }
            setStatusD(isCorrect ? 'success' : 'error')
            if (!isCorrect) {
              setTimeout(() => setStatusD(null), 2000)
            }
            break
        }
      }
      aIndex++
    }

    if (isCorrect) {
      refGuide?.current?.openModal([getRndFromArray(Game3Map.correctMessages)])
      const nextCorrectAnimals = [...correctAnimals, id]
      const nextAnimal = getRndFromArray([...displayedAnimals].filter(a => !nextCorrectAnimals.includes(a.id)))
      setCorrectAnimals(nextCorrectAnimals)
      setCurrentAnimal(nextAnimal)
      if (!nextAnimal) {
        const timeMs = +new Date() - gameStartTime
        patchState({
          timeMs: state.timeMs + timeMs,
          games: { ...state.games, game3: { score: state.score + 1, errors: state.errors, timeMs } },
          score: state.score + 1,
        })
        setGameEndTime(+new Date())
        setIsFinished(true)
        refGuide.current?.playSound()
        refGuide?.current?.onGameEnd(state.errors)
      } else {
        patchState({ score: state.score + 1 })
      }
    } else {
      refGuide?.current?.openModal([getRndFromArray(Game3Map.errorMessages)])
      patchState({ errors: state.errors + 1 })
    }
  }

  const showAnimalInfo = (animal: any) => {
    refModalImage?.current?.openModal(animal?.imgDetail)
  }

  const exitGame = () => {
    setAllAnimals(null)
    setDisplayedAnimals([])
    setCurrentAnimal(null)
    setIsInitialized(false)
    setTimeout(() => history.push('/dashboard'))
  }

  if (!isInitialized || !displayedAnimals) {
    return <Loader />
  }
  return (
    <div className="view background-winter">
      <div className="p-5 text-black view-content">
        <h1 className="text-3xl text-center font-bold w-full">Lesní stopař</h1>
        <ScoreStats
          isCompact={true}
          isTimeShown={true}
          startTime={gameStartTime}
          endTime={gameEndTime}
          customScore={state.score}
          customErrors={state.errors}
        />
        <SideNav customScore={state.score} customErrors={state.errors} customText={Game3Map.intro} />
        <div style={{ zIndex: 99 }}>
          <Guide ref={refGuide} isWinter={true} hasWinterGearA={true} hasWinterGearB={true} />
        </div>
        <GameFrame
          isFinished={isFinished}
          onExit={exitGame}
          childrenLeft={
            <div className="w-full">
              <div className="flex flex-row justify-around pl-10 pr-10">
                <div style={{ width: `${imgWidth}px`, height: `${imgWidth * 0.8}px` }}>
                  {displayedAnimals?.length > 0 && (
                    <Img
                      src={displayedAnimals[0].imgFootprint}
                      scale={1.02}
                      title={''}
                      width={`${imgWidth}px`}
                      hasError={statusA === 'error'}
                      onClick={() => selectAnimal(displayedAnimals[0].id)}
                    />
                  )}
                  {statusA === 'success' && (
                    <button
                      className="btn glass text-black"
                      style={{ position: 'relative', top: '-60px' }}
                      onClick={() => showAnimalInfo(displayedAnimals[0])}
                    >
                      Čeho si všímat
                    </button>
                  )}
                </div>
                <div style={{ width: `${imgWidth}px`, height: `${imgWidth * 0.8}px` }}>
                  {displayedAnimals?.length > 1 && (
                    <Img
                      src={displayedAnimals[1].imgFootprint}
                      scale={1.02}
                      title={''}
                      width={`${imgWidth}px`}
                      hasError={statusB === 'error'}
                      onClick={() => selectAnimal(displayedAnimals[1].id)}
                    />
                  )}
                  {statusB === 'success' && (
                    <button
                      className="btn glass text-black"
                      style={{ position: 'relative', top: '-60px' }}
                      onClick={() => showAnimalInfo(displayedAnimals[1])}
                    >
                      Čeho si všímat
                    </button>
                  )}
                </div>
              </div>
              <div className="flex flex-row justify-around pl-10 pr-10">
                <div style={{ width: `${imgWidth}px`, height: `${imgWidth * 0.8}px` }}>
                  {displayedAnimals?.length > 2 && (
                    <Img
                      src={displayedAnimals[2].imgFootprint}
                      scale={1.02}
                      title={''}
                      width={`${imgWidth}px`}
                      hasError={statusC === 'error'}
                      onClick={() => selectAnimal(displayedAnimals[2].id)}
                    />
                  )}
                  {statusC === 'success' && (
                    <button
                      className="btn glass text-black"
                      style={{ position: 'relative', top: '-60px' }}
                      onClick={() => showAnimalInfo(displayedAnimals[2])}
                    >
                      Čeho si všímat
                    </button>
                  )}
                </div>
                <div style={{ width: `${imgWidth}px`, height: `${imgWidth * 0.8}px` }}>
                  {displayedAnimals?.length > 3 && (
                    <Img
                      src={displayedAnimals[3].imgFootprint}
                      scale={1.02}
                      title={''}
                      width={`${imgWidth}px`}
                      hasError={statusD === 'error'}
                      onClick={() => selectAnimal(displayedAnimals[3].id)}
                    />
                  )}
                  {statusD === 'success' && (
                    <button
                      className="btn glass text-black"
                      style={{ position: 'relative', top: '-60px' }}
                      onClick={() => showAnimalInfo(displayedAnimals[3])}
                    >
                      Čeho si všímat
                    </button>
                  )}
                </div>
              </div>
            </div>
          }
          childrenRight={
            !isFinished &&
            currentAnimal && (
              <div className="w-full card shadow-xl p-2 glass opacity-90" style={{ height: `${imgWidth * 0.629}px` }}>
                <div className="overflow-hidden rounded-xl">
                  <Img src={currentAnimal.img} title={''} width={`${imgWidth * 0.629}px`} onClick={() => null} />
                </div>
              </div>
            )
          }
        />
        {/*<div className="flex flex-row mt-5" style={{ width: '100%' }}>*/}
        {/*  <div style={{ width: 'auto' }}>*/}
        {/*    <div className="flex flex-row">*/}
        {/*      <div style={{ width: `${imgWidth}px`, height: `${imgWidth}px` }}>*/}
        {/*        {displayedAnimals?.length > 0 && <Img src={displayedAnimals[0].imgFootprint} title={displayedAnimals[0].label} width={`${imgWidth}px`} hasError={statusA === 'error'} onClick={() => selectAnimal(displayedAnimals[0].id)} />}*/}
        {/*        {statusA === 'success' &&*/}
        {/*        <button className="btn btn-link" style={{ position: 'relative', top: '-40px' }} onClick={() => showAnimalInfo(displayedAnimals[0])}>Čeho si všímat</button>*/}
        {/*        }*/}
        {/*      </div>*/}
        {/*      <div style={{ width: `${imgWidth}px`, height: `${imgWidth}px` }}>*/}
        {/*        {displayedAnimals?.length > 1 && <Img src={displayedAnimals[1].imgFootprint} title={displayedAnimals[1].label} width={`${imgWidth}px`} hasError={statusB === 'error'} onClick={() => selectAnimal(displayedAnimals[1].id)} />}*/}
        {/*        {statusB === 'success' &&*/}
        {/*        <button className="btn btn-link" style={{ position: 'relative', top: '-40px' }} onClick={() => showAnimalInfo(displayedAnimals[1])}>Čeho si všímat</button>*/}
        {/*        }*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className="flex flex-row">*/}
        {/*      <div style={{ width: `${imgWidth}px`, height: `${imgWidth}px` }}>*/}
        {/*        {displayedAnimals?.length > 2 && <Img src={displayedAnimals[2].imgFootprint} title={displayedAnimals[2].label} width={`${imgWidth}px`} hasError={statusC === 'error'} onClick={() => selectAnimal(displayedAnimals[2].id)} />}*/}
        {/*        {statusC === 'success' &&*/}
        {/*        <button className="btn btn-link" style={{ position: 'relative', top: '-40px' }} onClick={() => showAnimalInfo(displayedAnimals[2])}>Čeho si všímat</button>*/}
        {/*        }*/}
        {/*      </div>*/}
        {/*      <div style={{ width: `${imgWidth}px`, height: `${imgWidth}px` }}>*/}
        {/*        {displayedAnimals?.length > 3 && <Img src={displayedAnimals[3].imgFootprint} title={displayedAnimals[3].label} width={`${imgWidth}px`} hasError={statusD === 'error'} onClick={() => selectAnimal(displayedAnimals[3].id)} />}*/}
        {/*        {statusD === 'success' &&*/}
        {/*        <button className="btn btn-link" style={{ position: 'relative', top: '-40px' }} onClick={() => showAnimalInfo(displayedAnimals[3])}>Čeho si všímat</button>*/}
        {/*        }*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div style={{ height: `${imgWidth * 2}px`, overflow: 'hidden', width: '600px' }}>*/}
        {/*    <TransitionGroup>*/}
        {/*      <CSSTransition*/}
        {/*        timeout={200}*/}
        {/*        classNames='fade'*/}
        {/*        key={`${(currentAnimal?.id)}_foo`}>*/}
        {/*        <div className="ml-5" style={{ height: `${imgWidth * 2}px`, overflow: 'hidden', width: '315px' }}>*/}
        {/*          {currentAnimal &&*/}
        {/*          <Img src={currentAnimal.img} title={currentAnimal.label} width={`${imgWidth}px`} onClick={() => null} />*/}
        {/*          }*/}
        {/*          {isFinished ? (*/}
        {/*            <p className="text-left">*/}
        {/*              hotovo ...*/}
        {/*              <button className="btn btn-primary" onClick={exitGame}>exit</button>*/}
        {/*            </p>*/}
        {/*          ) : (*/}
        {/*            <p className="text-left">*/}
        {/*              Lesník na úvod řekne:*/}
        {/*              <br/>*/}
        {/*              Nejlépe se zvěř stopuje v zimě, na sněhu. Poznáš, kterému zvířeti patří která stopa?*/}
        {/*              <br/><br/>*/}
        {/*              Zadání úkolu*/}
        {/*              <br/>*/}
        {/*              Přiřaď fotku zvířete k jeho stopě. Pokud ji přiřadíš správně, po kliknutí na tlačítko „Čeho si všímat?“se dozvíš typické znaky každé stopy.*/}
        {/*            </p>*/}
        {/*          )}*/}
        {/*        </div>*/}
        {/*      </CSSTransition>*/}
        {/*    </TransitionGroup>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div>
          <ModalAlert ref={refModalAlert} />
        </div>
        <div>
          <ModalImage ref={refModalImage} />
        </div>
      </div>
    </div>
  )
}
